//E:\SAUDIDUNES11\frontend\src\pages\StorePage.js
import { useEffect, useState } from "react";
import { useParams, useNavigationType } from "react-router-dom";
import styled from "styled-components";

import Footer from "../components/Footer";
import Product from "../components/Product";
import { useLocation } from "react-router-dom";

/* ---------- Styled Components ---------- */

const Wrapper = styled.div`
  margin-top: 100px;
  padding: 20px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

const StoreHeader = styled.div`
  margin-bottom: 30px;
  padding: 20px;
  background: #f3f3f3;
  border-radius: 10px;
  border: 1px solid #ddd;
`;

const StoreTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  color: #333;
`;

const StoreOwner = styled.p`
  margin: 5px 0 0 0;
  font-size: 18px;
  color: #666;
`;

const TabsContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
`;

const Tab = styled.button`
  padding: 10px 20px;
  border: none;
  border-bottom: 3px solid
    ${(props) => (props.active ? "teal" : "transparent")};
  background-color: transparent;
  cursor: pointer;
  font-size: 16px;
  font-weight: ${(props) => (props.active ? "600" : "400")};
  color: ${(props) => (props.active ? "teal" : "#555")};
  transition: all 0.2s ease;

  &:hover {
    color: teal;
  }
`;

const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
`;

const ProductCard = styled.div`
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 15px;
  background: white;
  text-align: center;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
`;

const ProductName = styled.h3`
  margin: 10px 0 5px 0;
  font-size: 18px;
`;

const ProductPrice = styled.p`
  margin: 0;
  font-size: 16px;
  color: teal;
  font-weight: bold;
`;

/* ---------- Store Page Component ---------- */

const StorePage = () => {

  
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const defaultTab = params.get("tab") || "cars";
  
  const { id } = useParams(); // store owner ID
  const navType = useNavigationType();
  const [owner, setOwner] = useState(null);
  const [cars, setCars] = useState([]);
  const [estates, setEstates] = useState([]);
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [loading, setLoading] = useState(true);
  
    
  
  useEffect(() => {
    if (!loading) {
      const prev = sessionStorage.getItem("prevPage");
      const saved = sessionStorage.getItem("storeScroll");
      
      // ⭐ Add your logs here
       console.log("prevPage =", prev);
      console.log("storeScroll =", saved);
      
      if (prev === "store" && saved) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(saved));
        }, 0);
      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "auto"
        });
         // reset to top
      }
  
      sessionStorage.removeItem("prevPage");
      sessionStorage.removeItem("storeScroll");
    }
  }, [loading]);
  
  

  
  useEffect(() => {
    if (owner?.storeName) {
      document.title = owner.storeName;
    }
  }, [owner]);
  

  /* Fetch store owner + products */
  useEffect(() => {
    const fetchStoreData = async () => {
      try {

        setLoading(true); // ⭐ Correct place

        // Fetch owner
        const ownerRes = await fetch(`/api/auth/user/${id}`);
        const ownerData = await ownerRes.json();

        // Fetch cars
        const carsRes = await fetch(`/api/AffordableCars/owner/${id}`);
        const carsData = await carsRes.json();

        // Fetch real estate
        const estatesRes = await fetch(`/api/AffordableRealestates/owner/${id}`);
        const estatesData = await estatesRes.json();

        setOwner(ownerData);
        setCars(carsData);
        setEstates(estatesData);
      } catch (err) {
        console.error("Error loading store:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStoreData();
  }, [id,location.search]);


  

  if (loading) {
    return (
      <Wrapper>
        <h2>Loading store...</h2>
      </Wrapper>
    );
  }

  if (!owner) {
    return (
      <Wrapper>
        <h2>Store not found</h2>
      </Wrapper>
    );
  }

  

  return (
    <div>
      

      <Wrapper>
        <StoreHeader>
          <StoreTitle>{owner.storeName}</StoreTitle>
          <StoreOwner>Owned by: {owner.name}</StoreOwner>
        </StoreHeader>

        {/* Tabs */}
        <TabsContainer>
          <Tab active={activeTab === "cars"} onClick={() => setActiveTab("cars")}>
            Cars
          </Tab>
          <Tab
            active={activeTab === "realestate"}
            onClick={() => setActiveTab("realestate")}
          >
            Real Estate
          </Tab>
        </TabsContainer>

        {/* Cars Section */}
        {activeTab === "cars" && (
          <>
            {cars.length === 0 ? (
              <p>No cars found for this store.</p>
            ) : (
              <ProductsGrid>
                

               {cars.map((c) => (
                 <Product key={c._id} item={c} mode="car" fromStore={true} openInNewTab={false} /> 
                 ))}

              </ProductsGrid>
            )}
          </>
        )}

        {/* Real Estate Section */}
        {activeTab === "realestate" && (
          <>
            {estates.length === 0 ? (
              <p>No real estate listings found for this store.</p>
            ) : (
              <ProductsGrid>
                

                {estates.map((e) => (
                   <Product key={e._id} item={e} mode="realestate" fromStore={true} openInNewTab={false} /> 
                 ))}

              </ProductsGrid>
            )}
          </>
        )}
      </Wrapper>

      <Footer />
    </div>
  );
};

export default StorePage;
